import { Delete, Edit, MoreVert } from '@mui/icons-material';
import {
  Checkbox,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem
} from '@mui/material';
import { Option } from '@thro-types/leihbar';

import parse from 'html-react-parser';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ResponsiveImage } from 'app/components/ResponsiveImage';
import { translations } from 'locales/i18n';

interface Props {
  option: Option;
  inModalView?: true;
  isSelected: boolean;
  handleToggle: () => void;
  handleEditClick?: never;
  handleDeleteClick?: never;
  userCanEdit?: boolean;
}

interface PropsWithActions {
  option: Option;
  inModalView?: false;
  handleEditClick: (option: Option) => void;
  handleDeleteClick: (option: Option) => void;
  userCanEdit: boolean;
}

type FinalProps = Props | PropsWithActions;

export const OptionDetail = (props: FinalProps) => {
  const { t } = useTranslation();
  const userCanEdit = props.userCanEdit;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const handleSettingsMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
    event.preventDefault();
  };
  const handleSettingsMenuClose = (event: React.MouseEvent) => {
    setAnchorEl(null);
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Grid container className="product-detail__option-detail">
      <Grid item xs={5} lg={3} alignSelf={'center'}>
        <ResponsiveImage src={props.option.image} style={{ padding: '0.5em' }} />
      </Grid>
      <Grid container item xs={5} lg={7} className="product-detail__option-detail__info">
        <Grid item xs={12} className="product-detail__option-detail__title">
          {props.option.title}
        </Grid>
        {/* <Grid item xs={4}>
          {`${t(translations.pages.leihbar.option.create.count())}: ${props.option.amount}`}
        </Grid> */}
        <Grid item xs={12}>
          {parse(props.option.description)}
        </Grid>
      </Grid>
      <Grid
        container
        item
        xs={2}
        lg={2}
        flexDirection={'column'}
        justifyContent={'space-between'}
        alignItems={'end'}
      >
        {userCanEdit && !props.inModalView && (
          <Grid item xs={12} className="product-detail__option-detail__edit">
            <IconButton
              aria-label="settings"
              onClick={e => {
                handleSettingsMenuClick(e);
              }}
            >
              <MoreVert />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleSettingsMenuClose}
              className="event-card__menu"
            >
              <MenuItem
                onClick={e => {
                  props.handleEditClick && props.handleEditClick(props.option);
                  handleSettingsMenuClose(e);
                }}
              >
                <ListItemIcon>
                  <Edit sx={{ color: 'lightblue' }} />
                </ListItemIcon>
                <ListItemText>{t(translations.common.edit())}</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={e => {
                  props.handleDeleteClick && props.handleDeleteClick(props.option);
                  handleSettingsMenuClose(e);
                }}
              >
                <ListItemIcon>
                  <Delete sx={{ color: 'red' }} />
                </ListItemIcon>
                <ListItemText>{t(translations.common.delete())}</ListItemText>
              </MenuItem>
            </Menu>
          </Grid>
        )}
        {props.inModalView && (
          <Grid item xs={6} style={{ position: 'relative' }}>
            {/* <SpeedDial
              ariaLabel="add to Shopping Cart"
              className="add-to-shoppingcart"
              icon={<AddShoppingCart style={{ color: 'white' }} />}
              onClick={() => {
                handleAddToCart();
              }}
            /> */}
            <Checkbox
              className="add-to-shoppingcart"
              onClick={() => {
                props.handleToggle();
              }}
              checked={props.isSelected}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
